import * as React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { EditPage } from '../edit_page/EditPage';
import { metersRestCrudThunksForSupplier } from '../../thunks/meters_thunks';
import SupplierMeterForm from '../supplier_meter_form/SupplierMeterForm';

const style = require('./SupplierEditMeterPage.less');

class SupplierEditMeterPage extends React.Component<any, any> {
	state = {
		loading: true,
		meterDetail: {},
	};

	componentDidMount() {
		const { getMeter, match } = this.props;
		const meterId = match.params.id;
		getMeter(meterId).then((meter) => {
			this.setState({
				loading: false,
				meterDetail: meter,
			});
		});
	}

	render() {
		const { history } = this.props;

		//noinspection TypeScriptUnresolvedVariable
		return [
			<EditPage
				title="Edit Meter"
				formComponentProps={{
					formData: this.state.meterDetail,
					onSuccess: (rec) => history.push(`/supplier/meters/detail/${rec.id}`),
				}}
				fetching={this.state.loading}
				FormComponent={SupplierMeterForm}
			/>,
		];
	}
}

const mapStateToProps = (state, ownProps) => {
	return {
		history: ownProps.history,
		match: ownProps.match,
	};
};

const mapDispatchToProps = (dispatch) => ({
	getMeter: (id) => dispatch(metersRestCrudThunksForSupplier.readOne(id)),
});

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SupplierEditMeterPage));
